import { store, useAppDispatch } from 'modules/Editor/store';
import { selectPageOrder } from 'modules/Editor/store/infographSelector';
import { moveToPage } from 'modules/Editor/store/pageControlSlice';
import { useEffect } from 'react';

/**
 * Hook to handle page link click event
 * Any widgets wrapped in <a> tag with data-page-id attribute will be handled by this hook
 * Clicking on the tag will move the user to the page with the specified page id if it exists
 *
 * Optionally pass in callback to be called after moving to the page
 */
export const usePageLink = (callback?: (pageId: string) => void) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handlePageClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target) return;

      const link = target.closest('a[data-page-id]');
      if (!link || !link.hasAttribute('data-page-id')) return;

      const pageId = link.getAttribute('data-page-id');
      if (!pageId) return;

      const pageOrder = selectPageOrder(store.getState());
      if (!pageOrder.includes(pageId)) return;
      e.preventDefault();
      dispatch(moveToPage({ pageOrder, pageId }));
      callback?.(pageId);
    };

    document.addEventListener('click', handlePageClick);

    return () => {
      document.removeEventListener('click', handlePageClick);
    };
  }, [dispatch, callback]);
};
